import { BrowserRouter } from 'react-router-dom';
import { Suspense } from 'react';
import { AppRoutes } from './router';
import RemarketingSegments from './components/feature/RemarketingSegments';

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <Suspense fallback={
        <div className="min-h-screen flex items-center justify-center bg-white">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-teal-600 mx-auto mb-4"></div>
            <p className="text-gray-600">Načítání...</p>
          </div>
        </div>
      }>
        <AppRoutes />
      </Suspense>
      <RemarketingSegments />
    </BrowserRouter>
  );
}

export default App;
